import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { Loading } from "../../components/common/Loading";
import { fullUrl } from "../../utils/Helpers";

interface StudentProfileCardProps {
  loading: boolean;
  student: any;
}

const resolveStudentName = (student: any) => {
  if (!student) {
    return "";
  }

  const composed = [student.firstname, student.othername, student.lastname]
    .filter(Boolean)
    .join(" ")
    .trim();

  return composed || student.name || "";
};

const resolveAvatar = (student: any) => {
  if (!student) {
    return null;
  }

  if (student.avatarUrl) {
    return student.avatarUrl;
  }

  if (student.photo) {
    return fullUrl(student.photo);
  }

  if (student.photo_path) {
    return fullUrl(student.photo_path);
  }

  return null;
};

const StudentProfileCard = ({ loading, student }: StudentProfileCardProps) => {
  const studentName = resolveStudentName(student);
  const avatar = resolveAvatar(student);

  return (
    <Card>
      <CardBody>
        {loading && <Loading label="Loading student..." />}
        {!loading && student && (
          <Row className="align-items-center">
            <Col md={2} className="text-center">
              {avatar ? (
                <img
                  src={avatar}
                  alt={studentName}
                  className="rounded-circle"
                  style={{ width: 96, height: 96, objectFit: "cover" }}
                />
              ) : (
                <div
                  className="rounded-circle bg-light d-inline-flex align-items-center justify-content-center text-muted"
                  style={{ width: 96, height: 96 }}
                >
                  <i className="fas fa-user fa-2x"></i>
                </div>
              )}
            </Col>
            <Col md={10}>
              <h4 className="mb-3">{studentName}</h4>
              <Row>
                <Col md={3} className="mb-2">
                  <div className="dt-label text-muted small">Student ID</div>
                  <div className="dt-value">{student.studentid || "—"}</div>
                </Col>
                <Col md={3} className="mb-2">
                  <div className="dt-label text-muted small">Class</div>
                  <div className="dt-value">
                    {[student.form, student.stream].filter(Boolean).join(" ") || "—"}
                  </div>
                </Col>
                <Col md={3} className="mb-2">
                  <div className="dt-label text-muted small">House</div>
                  <div className="dt-value">{student.house?.trim() || "—"}</div>
                </Col>
                <Col md={3} className="mb-2">
                  <div className="dt-label text-muted small">Status</div>
                  <div className="dt-value">{student.status || "—"}</div>
                </Col>
                <Col md={12} className="mb-2">
                  <div className="dt-label text-muted small">Campus</div>
                  <div className="dt-value">{student.campus || "—"}</div>
                </Col>
              </Row>
            </Col>
          </Row>
        )}
      </CardBody>
    </Card>
  );
};

export default StudentProfileCard;
